import React from 'react';

import { TagProps } from 'antd/lib/tag';

import * as Styled from './Tag.style';

export type Props = TagProps;

export const Tag = (props: Props): JSX.Element => <Styled.Tag {...props} />;
